import { isEmpty } from 'lodash';

export const CHAT_GROUP_ID_NOT_SELECTED = '';
export const CHAT_SYNTHETIC_OVERSEEN_GROUP_ID = 'synthetic overseen';
const ADMIN_SUBSCRIBED_GROUP_NAME = 'Subscribed';

const initState = {
  loading: false,
  chatWindowOpen: false,
  createdUserChat: false,
  chatRooms: [],
  chatGroups: [],
  activeRoom: undefined,
  updateCount: 0,
  scrollDownChat: 0,
  newMessagesCount: 0,
  newMessageId: null,
  lastMessageReceivedFrom: null,
  roomIdToGroupMap: {},
  roomIdToGroupMapOverseen: {},
  chatRoomDetailsUser: null,
};

const ChatReducer = function (state = initState, action) {
  switch (action.type) {
    case 'OPEN_CHAT_WINDOW': {
      return {
        ...state,
        chatWindowOpen: true,
      };
    }

    case 'TOGGLE_CHAT_WINDOW': {
      return {
        ...state,
        chatWindowOpen: !state.chatWindowOpen,
      };
    }

    case 'CREATED_USER_CHAT': {
      return {
        ...state,
        createdUserChat: !state.createdUserChat,
      };
    }

    case 'SET_ACTIVE_CHAT_ROOM': {
      return {
        ...state,
        activeRoom: action.chatRoomId,
      };
    }

    case 'SET_CHAT_ROOM_DETAILS_USER': {
      return {
        ...state,
        chatRoomDetailsUser: action.activeChatRoom,
      };
    }

    case 'UPDATE_CHAT_NOTIFICATION_SETTING': {
      const { updateCount } = state;
      return {
        ...state,
        updateCount: updateCount + 1,
      };
    }

    case 'GET_CHAT_ROOMS_PENDING': {
      return { ...state, loading: true };
    }

    case 'GET_CHAT_ROOMS_REJECTED': {
      return { ...state, loading: false };
    }

    case 'GET_CHAT_ROOMS_FULFILLED': {
      const { chatGroups: responseChatGroups, loggedUser } = action.payload;
      const nextRoomIdToGroupMap = {};
      const nextRoomIdToGroupMapOverseen = { ...state.roomIdToGroupMapOverseen };

      const visibleChatGroups = loggedUser?.isAdmin
        ? responseChatGroups.filter((group) => group.groupName !== ADMIN_SUBSCRIBED_GROUP_NAME)
        : responseChatGroups;

      let tempChatRoomGroups = mapChatGroups(
        visibleChatGroups,
        nextRoomIdToGroupMap,
        nextRoomIdToGroupMapOverseen
      );

      if (loggedUser?.isAdminClient || (loggedUser?.isAdmin && action.meta?.viewingOwnerId)) {
        tempChatRoomGroups =
          createAndAddOverseenContainerGroup(tempChatRoomGroups);
      }

      return {
        ...state,
        loading: false,
        chatGroups: tempChatRoomGroups,
        roomIdToGroupMap: nextRoomIdToGroupMap,
        roomIdToGroupMapOverseen: nextRoomIdToGroupMapOverseen,
        activeRoom: getPersistedActiveRoom(
          state.activeRoom,
          nextRoomIdToGroupMap,
          nextRoomIdToGroupMapOverseen
        ),
      };
    }

    case 'SAVE_CHAT_MESSAGE_TO_ROOM': {
      const { activeRoom, chatGroups, roomIdToGroupMap } = state;
      let { scrollDownChat, newMessagesCount } = state;

      let chatRooms = findChatRoomsByRoomIdSafely(
        chatGroups,
        roomIdToGroupMap,
        action.roomId
      );

      if (!chatRooms || !action.roomId) {
        return {
          ...state,
          loading: false,
        };
      }

      let indexToUpdate;
      indexToUpdate = chatRooms
        .map(function (r) {
          return r.roomId;
        })
        .indexOf(Number(action.roomId));

      if (indexToUpdate < 0) {
        return {
          ...state,
          loading: false,
        };
      }

      const found = chatRooms[indexToUpdate].messages.findIndex(
        (message) => message.messageId === action.message.messageId
      );

      if (found < 0) {
        chatRooms[indexToUpdate].messages.push(action.message);
      } else {
        chatRooms[indexToUpdate].messages[found] = action.message;
      }

      if (
        chatRooms[indexToUpdate].newMessageId == null &&
        !action.recipientIsSender
      ) {
        chatRooms[indexToUpdate].newMessageId = action.message.messageId;
      }

      if (action.recipientIsSender) {
        chatRooms[indexToUpdate].lastSeenMessageId = action.message.messageId;
        chatRooms[indexToUpdate].newMessageId = null;
        chatRooms[indexToUpdate].roomSaw = true;
        chatRooms[indexToUpdate].messagesCount = 0;
      } else if (found < 0) {
        newMessagesCount += 1;
        chatRooms[indexToUpdate].roomSaw = false;
        if (action.updateCounter) {
          chatRooms[indexToUpdate].messagesCount += 1;
        }
      }

      if (activeRoom == action.roomId) {
        scrollDownChat += 1;
      }

      return {
        ...state,
        loading: false,
        chatGroups: [...chatGroups],
        scrollDownChat,
        newMessagesCount,
        lastMessageReceivedFrom: action.message.userId,
      };
    }

    case 'GET_CHAT_ROOM_MESSAGES_PENDING': {
      return { ...state, loading: true };
    }

    case 'SET_CHAT_LOADING': {
      return { ...state, loading: action.loading, uploadStatus: action.loading ? state.uploadStatus : null };
    }

    case 'SET_CHAT_UPLOAD_STATUS': {
      return { ...state, uploadStatus: action.status };
    }

    case 'UPLOAD_FILE_PENDING': {
      return { ...state, loading: true };
    }

    case 'UPLOAD_FILE_REJECTED': {
      return { ...state, loading: false, uploadStatus: null };
    }

    case 'UPLOAD_FILE_FULFILLED': {
      return { ...state, loading: false, uploadStatus: null };
    }

    case 'GET_CHAT_ROOM_MESSAGES_REJECTED': {
      return { ...state, loading: false };
    }

    case 'GET_CHAT_ROOM_MESSAGES_FULFILLED': {
      const { chatGroups, activeRoom, roomIdToGroupMap } = state;

      const chatRooms = findChatRoomsByRoomIdSafely(
        chatGroups,
        roomIdToGroupMap,
        activeRoom
      );

      if (!chatRooms || !activeRoom) {
        return {
          ...state,
          loading: false,
        };
      }

      let indexToUpdate;
      indexToUpdate = chatRooms
        .map(function (r) {
          return r.roomId;
        })
        .indexOf(activeRoom);

      if (indexToUpdate < 0) {
        return {
          ...state,
          loading: false,
        };
      }

      // Merge the fetched (older) page in front of what's already loaded,
      // deduping by messageId. Without this, a re-fired pagination load
      // (e.g. a short room sitting at scrollTop 0 so every new message
      // triggers handleScroll -> loadMessages) re-appends overlapping
      // messages and the same message renders many times until refresh.
      const fetchedMessages = action.payload ?? [];
      const existingMessages = chatRooms[indexToUpdate].messages ?? [];
      const existingMessageIds = new Set(
        existingMessages.map((mes) => mes.messageId)
      );
      const uniqueFetchedMessages = fetchedMessages.filter(
        (mes) => !existingMessageIds.has(mes.messageId)
      );

      chatRooms[indexToUpdate].messages = [
        ...uniqueFetchedMessages,
        ...existingMessages,
      ];

      return {
        ...state,
        loading: false,
        /*chatRooms,*/
        chatGroups,
      };
    }
    case 'UPDATE_CHAT_NOTIFICATION_DATA_FULFILLED': {
      const { chatGroups, roomIdToGroupMap } = state;

      const roomsForUpdate = action.payload;

      roomsForUpdate.map((roomForUpdate) => {
        const chatRooms = findChatRoomsByRoomIdSafely(
          chatGroups,
          roomIdToGroupMap,
          roomForUpdate.ChatRoomID
        );

        if (!chatRooms) {
          return roomForUpdate;
        }

        let indexToUpdate;
        if (chatRooms && roomForUpdate) {
          indexToUpdate = chatRooms
            .map(function (r) {
              return r.roomId;
            })
            .indexOf(roomForUpdate.ChatRoomID);
        }

        if (indexToUpdate < 0) {
          return roomForUpdate;
        }

        chatRooms[indexToUpdate].messagesCount = roomForUpdate.UnreadMessages;
      });

      return { ...state, chatGroups: [...chatGroups] };
    }

    case 'SET_MESSAGE_SEEN': {
      const { chatGroups, activeRoom, roomIdToGroupMap } = state;
      const chatRooms = findChatRoomsByRoomIdSafely(
        chatGroups,
        roomIdToGroupMap,
        activeRoom
      );

      const chatGroupId = roomIdToGroupMap[activeRoom];
      if (!chatGroupId || !chatGroupId.length) {
        return { ...state };
      }

      const chatGroup = chatGroups.find((x) => x.groupId === chatGroupId[0]);
      if (!chatGroup) {
        return { ...state };
      }

      if (!chatRooms || !activeRoom) {
        return {
          ...state,
        };
      }

      const indexToUpdate = chatRooms.findIndex((x) => x.roomId === activeRoom);
      if (indexToUpdate < 0) {
        return {
          ...state,
        };
      }

      for (let i = 0; i < chatRooms[indexToUpdate].messages.length; i++) {
        const x = chatRooms[indexToUpdate].messages[i];

        if (x.messageId === action.messageId) {
          x.seen = true;
          chatRooms[indexToUpdate].messages[i] = x;
          break;
        }
      }

      let newMessagesCount = chatRooms[indexToUpdate].messagesCount - 1;
      if (newMessagesCount < 0) {
        newMessagesCount = 0;
      }

      chatRooms[indexToUpdate] = {
        ...chatRooms[indexToUpdate],
        lastSeenMessageId: action.messageId,
        newMessageId: null,
        messagesCount: newMessagesCount,
        roomSaw: newMessagesCount === 0,
      };

      chatGroup.chatRooms = chatRooms;

      return { ...state, chatGroups: [...chatGroups] };
    }
    case 'RESET_NEW_MESSAGES_COUNT': {
      return { ...state, newMessagesCount: 0 };
    }

    // Live avatar patch (SignalR UserAvatarChanged): swap the changed user's
    // picture on their rooms and on their already-loaded messages so the chat
    // list updates instantly instead of waiting for a refresh.
    case 'USER_AVATAR_CHANGED': {
      const patchRoom = (room) => {
        const roomMatches = room.clientId === action.userId;
        const hasMessage = room.messages?.some((m) => m.userId === action.userId);
        if (!roomMatches && !hasMessage) return room;
        return {
          ...room,
          ...(roomMatches ? { avatar: action.avatar } : {}),
          messages: room.messages?.map((m) =>
            m.userId === action.userId ? { ...m, avatar: action.avatar } : m
          ),
        };
      };

      const patchGroup = (group) => ({
        ...group,
        chatRooms: group.chatRooms.map(patchRoom),
        // Overseen container nests its groups one level down.
        chatGroups: group.chatGroups?.map((nested) => ({
          ...nested,
          chatRooms: nested.chatRooms.map(patchRoom),
        })),
      });

      return { ...state, chatGroups: state.chatGroups.map(patchGroup) };
    }

    case 'UPDATE_CHAT_MESSAGE_TEXT': {
      const { chatGroups, roomIdToGroupMap } = state;

      let chatRooms;
      try {
        chatRooms = findChatRoomsByRoomId(chatGroups, roomIdToGroupMap, action.roomId);
      } catch {
        return state;
      }

      const indexToUpdate = chatRooms.map((r) => r.roomId).indexOf(Number(action.roomId));
      if (indexToUpdate < 0) return state;

      const msgIndex = chatRooms[indexToUpdate].messages.findIndex(
        (m) => m.messageId === action.messageId
      );
      if (msgIndex < 0) return state;

      chatRooms[indexToUpdate].messages[msgIndex] = {
        ...chatRooms[indexToUpdate].messages[msgIndex],
        message: action.newText,
      };

      return { ...state, chatGroups };
    }
    case 'GET_OVERSEEN_CHAT_GROUPS_PENDING': {
      return loadingOverseenGroupsReduxHandler(state, true);
    }
    case 'GET_OVERSEEN_CHAT_GROUPS_REJECTED': {
      return loadingOverseenGroupsReduxHandler(state, false);
    }
    case 'GET_OVERSEEN_CHAT_GROUPS_FULFILLED': {
      const { chatGroups } = state;

      const overseenChatGroupIndex = chatGroups.findIndex(
        (cg) => cg.groupId === CHAT_SYNTHETIC_OVERSEEN_GROUP_ID
      );

      if (overseenChatGroupIndex < 0) {
        return state;
      }

      const nextRoomIdToGroupMapOverseen = {};
      const nextChatGroups = [...chatGroups];
      const overseenChatGroup = nextChatGroups[overseenChatGroupIndex];

      nextChatGroups[overseenChatGroupIndex] = {
        ...overseenChatGroup,
        chatGroups: mapChatGroups(
          action.payload,
          state.roomIdToGroupMap,
          nextRoomIdToGroupMapOverseen,
          true
        ),
        nestedChatGroupsLoaded: true,
      };

      return {
        ...state,
        chatGroups: nextChatGroups,
        roomIdToGroupMapOverseen: nextRoomIdToGroupMapOverseen,
        activeRoom: getPersistedActiveRoom(
          state.activeRoom,
          state.roomIdToGroupMap,
          nextRoomIdToGroupMapOverseen
        ),
      };
    }

    case 'GET_OVERSEEN_ADDITIONAL_CHAT_ROOM_MESSAGES_PENDING':
    case 'GET_OVERSEEN_CHAT_ROOM_MESSAGES_PENDING': {
      return loadingOverseenRoomMessagesReduxHandler(
        state,
        action.meta.roomId,
        true
      );
    }

    case 'GET_OVERSEEN_ADDITIONAL_CHAT_ROOM_MESSAGES_REJECTED':
    case 'GET_OVERSEEN_CHAT_ROOM_MESSAGES_REJECTED': {
      return loadingOverseenRoomMessagesReduxHandler(
        state,
        action.meta.roomId,
        false
      );
    }

    case 'GET_OVERSEEN_CHAT_ROOM_MESSAGES_FULFILLED': {
      const { chatGroups, roomIdToGroupMapOverseen } = state;

      const chatRooms = findChatRoomsByRoomIdSafely(
        chatGroups,
        roomIdToGroupMapOverseen,
        action.meta.roomId
      );

      if (!chatRooms) {
        return {
          ...state,
          chatGroups,
        };
      }

      const foundChatRoom = chatRooms.find(
        (cr) => cr.roomId === action.meta.roomId
      );
      if (!foundChatRoom) {
        return {
          ...state,
          chatGroups,
        };
      }
      foundChatRoom.messages = action.payload;
      foundChatRoom.messagesLoaded = true;

      return {
        ...state,
        chatGroups,
      };
    }

    case 'GET_OVERSEEN_ADDITIONAL_CHAT_ROOM_MESSAGES_FULFILLED': {
      if (action.payload.length == 0) {
        return state;
      }

      const { chatGroups, roomIdToGroupMapOverseen } = state;

      const chatRooms = findChatRoomsByRoomIdSafely(
        chatGroups,
        roomIdToGroupMapOverseen,
        action.meta.roomId
      );

      if (!chatRooms) {
        return {
          ...state,
          chatGroups,
        };
      }

      const foundChatRoom = chatRooms.find(
        (cr) => cr.roomId === action.meta.roomId
      );
      if (!foundChatRoom) {
        return {
          ...state,
          chatGroups,
        };
      }
      foundChatRoom.messages = [...foundChatRoom.messages, ...action.payload];
      foundChatRoom.messagesLoaded = true;

      return {
        ...state,
        chatGroups,
      };
    }

    case 'MARK_ALL_MESSAGES_SEEN': {
      const { chatGroups, roomIdToGroupMap } = state;

      let chatRooms;
      try {
        chatRooms = findChatRoomsByRoomId(chatGroups, roomIdToGroupMap, action.roomId);
      } catch {
        return state;
      }

      const indexToUpdate = chatRooms.findIndex((r) => r.roomId === Number(action.roomId));
      if (indexToUpdate < 0) return state;

      const lastMsg = chatRooms[indexToUpdate].messages[chatRooms[indexToUpdate].messages.length - 1];

      const seenMessages = chatRooms[indexToUpdate].messages.map((m) =>
        m.seen ? m : { ...m, seen: true }
      );

      chatRooms[indexToUpdate] = {
        ...chatRooms[indexToUpdate],
        messages: seenMessages,
        messagesCount: 0,
        newMessageId: null,
        roomSaw: true,
        lastSeenMessageId: lastMsg?.messageId ?? chatRooms[indexToUpdate].lastSeenMessageId,
      };

      return { ...state, chatGroups: [...chatGroups] };
    }

    default:
      return state;
  }
};

// The "Unread" section is a PURE, on-demand VIEW over the exact same room
// objects that live in their normal category group - never a stored copy.
// It used to be a separately-dispatched (CREATE_UNREAD_GROUP) clone of each
// room, which is why a room could show two different unread counts in two
// places at once: the clone and the original could drift out of sync
// whenever only one of them got updated (e.g. MARK_ALL_MESSAGES_SEEN only
// ever touched the original). Deriving it fresh from `chatGroups` on every
// read makes that entire class of bug structurally impossible - there is
// only ever one copy of a room's unread state to read from.
export const UNREAD_GROUP_ID = 'Unread';

export function withUnreadChatGroup(chatGroups) {
  if (!chatGroups || chatGroups.length === 0) return chatGroups ?? [];

  const unreadRooms = chatGroups
    .flatMap((group) => group.chatRooms)
    .filter((room) => room.messagesCount > 0);

  if (unreadRooms.length === 0) return chatGroups;

  const unreadGroup = {
    chatGroups: [],
    chatRooms: unreadRooms,
    groupId: UNREAD_GROUP_ID,
    groupName: 'Unread',
    groupType: 5,
    overseen: false,
  };

  return [unreadGroup, ...chatGroups];
}

function mapChatGroups(
  chatRoomGroups,
  roomIdToGroupMap,
  roomIdToGroupMapOverseen,
  insideOverseenGroupContainer = false
) {
  let tempChatRoomGroups = chatRoomGroups.map((crg) => {
    if (!insideOverseenGroupContainer) {
      putIntoRoomIdToGroupMap(roomIdToGroupMap, crg.chatRooms, crg.groupId);
    } else {
      putIntoRoomIdToGroupMap(
        roomIdToGroupMapOverseen,
        crg.chatRooms,
        CHAT_SYNTHETIC_OVERSEEN_GROUP_ID,
        crg.groupId
      );
    }

    return {
      ...crg,
      loading: false,
      chatRooms: crg.chatRooms.map((cr) => ({
        ...cr,
        loading: false,
        messagesLoaded: !insideOverseenGroupContainer,
        overseen: insideOverseenGroupContainer,
      })),
      hasNestedGroups: false,
      nestedChatGroupsLoaded: false,
      chatGroups: [],
    };
  });

  return tempChatRoomGroups;
}

function createAndAddOverseenContainerGroup(chatRoomGroups) {
  chatRoomGroups.push({
    groupId: CHAT_SYNTHETIC_OVERSEEN_GROUP_ID,
    groupName: 'Overseen',
    groupType: -2,
    loading: false,
    overseen: true,
    hasNestedGroups: true,
    nestedChatGroupsLoaded: false,
    chatGroups: [],
    chatRooms: [],
  });

  return chatRoomGroups;
}

function putIntoRoomIdToGroupMap(roomIdToGroupMap, chatRooms, ...groupsIds) {
  chatRooms.forEach((cr) => (roomIdToGroupMap[cr.roomId] = groupsIds));
}
function removeFromRoomIdToGroupMap(roomIdToGroupMap, ...roomsIds) {
  roomsIds.forEach((roomId) => delete roomIdToGroupMap[roomId]);
}

export function findChatRoomsByRoomId(chatGroups, roomIdToGroupMap, roomId) {
  const chatGroupsIds = roomIdToGroupMap[roomId];

  let chatRooms;
  if (chatGroups && chatGroupsIds) {
    chatRooms = findChatRoomsByGroupsIds(chatGroups, chatGroupsIds);
  } else {
    throw new NotFoundChatGroupError('chatGroups or chatGroupsIds unknown');
  }

  return chatRooms;
}

export function findChatRoomsByRoomIdInRegularAndOverseen(state) {
  const { chatGroups, roomIdToGroupMap, roomIdToGroupMapOverseen, activeRoom } =
    state;

  let chatRooms;
  try {
    chatRooms = findChatRoomsByRoomId(chatGroups, roomIdToGroupMap, activeRoom);
  } catch (error) {
    if (error instanceof NotFoundChatGroupError) {
      try {
        chatRooms = findChatRoomsByRoomId(
          chatGroups,
          roomIdToGroupMapOverseen,
          activeRoom
        );
      } catch (fallbackError) {
        if (fallbackError instanceof NotFoundChatGroupError) {
          chatRooms = [];
        } else {
          throw fallbackError;
        }
      }
    } else {
      throw error;
    }
  }

  return chatRooms;
}

function findChatGroupByGroupsIds(chatGroups, chatGroupsIds) {
  if (!chatGroups || !chatGroupsIds) {
    throw new NotFoundChatGroupError('chatGroups or chatGroupsIds unknown');
  }

  let tempChatGroupsIds = [...chatGroupsIds];
  let currentChatGroups = chatGroups;
  let currentChatGroup;
  while (tempChatGroupsIds.length > 0) {
    let currentGroupId = tempChatGroupsIds.shift();
    currentChatGroup = currentChatGroups.find(
      (cg) => cg.groupId === currentGroupId
    );

    if (!currentChatGroup) {
      throw new NotFoundChatGroupError(
        `chatGroup unknown for groupId: ${currentGroupId}`
      );
    }

    if (tempChatGroupsIds.length > 0) {
      currentChatGroups = currentChatGroup.chatGroups ?? [];
    }
  }

  return currentChatGroup;
}

function findChatRoomsByGroupsIds(chatGroups, chatGroupsIds) {
  return findChatGroupByGroupsIds(chatGroups, chatGroupsIds).chatRooms ?? [];
}

function findChatRoomsByRoomIdSafely(chatGroups, roomIdToGroupMap, roomId) {
  try {
    return findChatRoomsByRoomId(chatGroups, roomIdToGroupMap, roomId);
  } catch (error) {
    if (error instanceof NotFoundChatGroupError) {
      return undefined;
    }

    throw error;
  }
}

function roomExistsInGroupMap(roomIdToGroupMap, roomId) {
  if (roomId === undefined || roomId === null || !roomIdToGroupMap) {
    return false;
  }

  return roomIdToGroupMap[roomId] !== undefined;
}

function getPersistedActiveRoom(
  activeRoom,
  roomIdToGroupMap,
  roomIdToGroupMapOverseen
) {
  return roomExistsInGroupMap(roomIdToGroupMap, activeRoom) ||
    roomExistsInGroupMap(roomIdToGroupMapOverseen, activeRoom)
    ? activeRoom
    : undefined;
}

function loadingOverseenGroupsReduxHandler(state, loading) {
  const { chatGroups } = state;

  const overseenChatGroupIndex = chatGroups.findIndex(
    (cg) => cg.groupId === CHAT_SYNTHETIC_OVERSEEN_GROUP_ID
  );

  const overseenChatGroup = chatGroups[overseenChatGroupIndex];
  overseenChatGroup.loading = loading;

  return {
    ...state,
    chatGroups,
  };
}

function loadingOverseenRoomMessagesReduxHandler(state, roomId, loading) {
  const { chatGroups, roomIdToGroupMapOverseen } = state;

  const chatRooms = findChatRoomsByRoomIdSafely(
    chatGroups,
    roomIdToGroupMapOverseen,
    roomId
  );

  if (!chatRooms) {
    return state;
  }

  const foundChatRoom = chatRooms.find((cr) => cr.roomId === roomId);
  if (!foundChatRoom) {
    return state;
  }

  foundChatRoom.loading = loading;

  return {
    ...state,
    chatGroups,
  };
}

class NotFoundChatGroupError extends Error {
  constructor(message) {
    super(message);
  }
}

export default ChatReducer;
